module.exports = __webpack_public_path__ + "img/wgh-bg.8441ee1b.png";